import { TableViewStore, BaseListViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityOrderService, FacilityOrderTemplateService } from "application/facility-order/services";
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { HistoryService } from "application/history/services";
import _ from 'lodash';
import { toDate } from 'core/utils';
import { action } from 'mobx';
import {GridMultilineCell} from 'core/components';

class FacilityOrderNewFlowHistoryListViewStore extends BaseListViewStore {
	constructor(rootStore) {
        const facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        const historyService = new HistoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
			autoInit: true,
			name: 'facility-order-history',
			routes: {},
			actions: () => {
				return {
					find: async params => {
						const facilityOrderId = this.rootStore.routerStore.routerState.params.id;

						const response = await historyService.findFacilityOrderHistory(_.extend(params, {
							facilityOrderId: facilityOrderId ? facilityOrderId : params.facilityOrderId
						}));

						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
										eventDate: item.eventDate && toDate(item.eventDate, true)
									}
								);
							}))
						});

						if (facilityOrderId || params.facilityOrderId) {
							this.setTitle(facilityOrderId ? facilityOrderId : params.facilityOrderId, facilityOrderService);
						}

						return responseData;
					}
				};
			},
		});

        this.queryUtility.onResetFilter = ()=> {
            this.facilityOrderPatientStore.setValue(null);
            this.facilityOrderPatientStore.filterTerm = '';

            this.facilityOrderTemplateStore.setValue(null);
            this.facilityOrderTemplateStore.filterTerm = '';

			this.onChangePatient();
        }

        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);

        this.facilityOrderPatientStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
				const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
                const response = await this.facilityOrderPatientService.find({ facilityOrderId: facilityOrderId, searchQuery: term, rpp: 25, embed: 'Patient', sort: "patient|asc", });
				
				this.facilityOrderTemplateStore.filterAsync();

				return _.map(response.data.item, item => {
					return {
						id: item.patientId,
						name: item.patient.lastName + ' ' + item.patient.firstName
					};
				});
             }
		});

        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        //this.initFacilityOrderTemplateStore();

        this.facilityOrderTemplateStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
				const facilityOrderId = this.rootStore.routerStore.routerState.params.id;
				
				const response = await this.facilityOrderTemplateService.find({ facilityOrderId: facilityOrderId, patientId: this.queryUtility.filter.patientId, subCategoryName: term, rpp: 25 });				
				return _.map(response.data.item, item => {
					return {
						id: item.id,
						name: item.itemCategoryName
					};
				});     
             }
		});
        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'eventDate',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.DATE_OF_CHANGE",
						width: 150						
					},
					{
						key: 'username',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.CORE_USER",
						width: 150,
						sortable: false
					},
					{
						key: 'tableName',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.ENTITY",
						width: 100,
						sortable: false
					},
					{
						key: 'patient',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.PATIENT",
						width: 100,
						sortable: false
					},
					{
						key: 'subCategory',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.CATEGORY",
						width: 100,
						sortable: false
					},
					{
						key: 'itemId',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.ITEM_ID",
						width: 100,
						sortable: false
					},
					{
						key: 'changes',
						title: "FACILITY_ORDER_HISTORY.LIST.COLUMNS.DESCRIPTION",
						cell: GridMultilineCell,
						sortable: false
					}					
				],
			})
		);
    }

	@action.bound
	async setTitle(facilityOrderId, facilityOrderService) {
		const facilityOrder = (await facilityOrderService.get(facilityOrderId, { embed: 'Facility' })).data;
		const facilityOrderTitle = `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`
		this.rootStore.titleStore.setTitle(`Facility Order History - ${facilityOrder.facility.name}`);
		this.rootStore.viewStore.setNavigationOptions({
			title: facilityOrderTitle
		});		
	}

	@action.bound
	onChangePatient() {
		this.queryUtility.filter.set('facilityOrderTemplateId', null);
		this.facilityOrderTemplateStore.setValue(null);
		this.facilityOrderTemplateStore.filterAsync();
	}
}

export default FacilityOrderNewFlowHistoryListViewStore;